function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import ActiveNotingLabel from 'components/ActiveNotingLabel';
import App from 'modules/App';
import messages from '../../messages';
import { useKpiLevel, useKpiUnitSymbol } from '../../hooks';
import styles from '../Cells.pcss';
import { getKpiLevelClass } from './helpers';
import Icon from './Icon';
const Cell = (_param)=>{
    var { type, value, onAddNote } = _param, props = _object_without_properties(_param, [
        "type",
        "value",
        "onAddNote"
    ]);
    const printMode = useSelector(App.selectors.printMode);
    const level = useKpiLevel(_object_spread({
        type,
        value
    }, props));
    const unitSymbol = useKpiUnitSymbol(type);
    const kpiLevelClass = getKpiLevelClass(level);
    const onClick = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        if (!onAddNote) {
            return;
        }
        const noteType = type[0].toUpperCase() + type.slice(1);
        const titleMessage = messages.indicators[type];
        onAddNote(noteType, {
            value,
            unitSymbol,
            status: level,
            titleMessage
        });
    };
    return /*#__PURE__*/ _jsxs("a", {
        href: "",
        className: cn(styles.kpiCell, 'col', {
            [styles.kpiCell_print]: printMode,
            activeNoting: onAddNote
        }),
        onClick: onClick,
        children: [
            onAddNote ? /*#__PURE__*/ _jsx(ActiveNotingLabel, {}) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.kpiCell__value, kpiLevelClass),
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        level: level
                    }),
                    value === null ? 'N/A' : /*#__PURE__*/ _jsxs("span", {
                        children: [
                            value,
                            /*#__PURE__*/ _jsx("span", {
                                className: cn(styles.kpiCell__value__unit, {
                                    'mx-0': unitSymbol === '%'
                                }),
                                children: unitSymbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.kpiCell__title,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.indicators[type]))
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Cell);
